import { UPDATE_HISTORY_NAVIGATION } from 'src/actions/navigationActions';

const initialState = '/';

const historyNavigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_HISTORY_NAVIGATION: {
      state = action.payload;
      return state;
    }

    default: {
      return state;
    }
  }
};

export default historyNavigationReducer;
